import api from './api';

export function createMatch(matchType, matchLength, player1, player2) {
  return api.post('/match', { match_type: matchType, match_length: matchLength, player1, player2 });
}

export function listMatches() {
  return api.get('/match');
}

export function getMatchState(matchId) {
  return api.get(`/match/${matchId}?view=state`);
}

export function getMatchMoves(matchId) {
  return api.get(`/match/${matchId}?view=moves`);
}

export function getMatchTranscript(matchId) {
  return api.get(`/match/${matchId}?view=transcript`);
}

export function getMatchHistory(matchId) {
  return api.get(`/match/${matchId}?view=history`);
}

export function matchAction(matchId, action, data = {}) {
  return api.post(`/match/${matchId}`, { action, ...data });
}

// Convenience wrappers
export const startGame = (matchId, firstPlayer = 1) =>
  matchAction(matchId, 'start-game', { first_player: firstPlayer });

export const rollDice = (matchId, player, dice) =>
  matchAction(matchId, 'roll', { player, dice });

export const makeMove = (matchId, player, notation) =>
  matchAction(matchId, 'move', { player, notation });

export const offerDouble = (matchId, player) =>
  matchAction(matchId, 'double', { player });

export const respondDouble = (matchId, player, takes) =>
  matchAction(matchId, 'respond', { player, takes });

export const endGame = (matchId, winner, result = 'normal') =>
  matchAction(matchId, 'end-game', { winner, result });

export const analyzeMatch = (matchId, depth = 2) =>
  matchAction(matchId, 'analyze', { depth });